export const state = {
    aWasCalled: false,
    activeWheels: false
}